"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _screenReaderOnly = require("../screen-reader-only");

var _spinner = require("../spinner");

var _utils = require("../utils");

var _inputFooter = require("./input-footer");

var _core = require("@emotion/core");

var _excluded = ["children", "progress", "inputId", "role", "aria-live", "aria-atomic", "aria-relevant", "shouldLiveAnnounce"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var RecommendedLengthFooterBase = function RecommendedLengthFooterBase(_ref) {
  var children = _ref.children,
      progress = _ref.progress,
      inputId = _ref.inputId,
      _ref$role = _ref.role,
      ariaRole = _ref$role === void 0 ? 'status' : _ref$role,
      _ref$ariaLive = _ref['aria-live'],
      ariaLive = _ref$ariaLive === void 0 ? 'polite' : _ref$ariaLive,
      _ref$ariaAtomic = _ref['aria-atomic'],
      ariaAtomic = _ref$ariaAtomic === void 0 ? 'true' : _ref$ariaAtomic,
      ariaRelevant = _ref['aria-relevant'],
      shouldLiveAnnounce = _ref.shouldLiveAnnounce,
      transferProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var ref = (0, _react.useRef)(null);
  var isManualAnnouncement = shouldLiveAnnounce !== undefined;
  (0, _react.useEffect)(function () {
    if (ref.current && !ref.current.closest('[data-test-component = "StencilReactInputWrapper"]') && !(0, _utils.envIsProduction)()) {
      console.warn('RecommendedLengthFooterBase should be used with InputWrapper');
    }
  }, []);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isTyping = _useState2[0],
      setIsTyping = _useState2[1]; // aria-describedby is working like live region on Windows Chrome.
  // In order to avoid it need to unlink when textarea input is typed


  var _useState3 = (0, _react.useState)(true),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      isLinkedToInput = _useState4[0],
      setIsLinkedToInput = _useState4[1];

  var error = transferProps.error,
      warning = transferProps.warning,
      id = transferProps.id;
  var icon = error || warning ? undefined : (0, _core.jsx)(_spinner.ProgressArc, {
    "aria-hidden": true,
    color: "primary70",
    opacity: 0.15,
    progress: progress,
    size: 16,
    strokeWidth: 4
  });

  var keyUpTimeout = _react.default.useRef();

  var handleKeyDown = (0, _react.useCallback)(function () {
    setIsLinkedToInput(false);

    if (isManualAnnouncement) {
      return;
    }

    setIsTyping(true);

    if (keyUpTimeout.current) {
      clearTimeout(keyUpTimeout.current);
    }
  }, [isManualAnnouncement]);
  var handleKeyUp = (0, _react.useCallback)(function (e) {
    if (isManualAnnouncement || e.key === _utils.EventKeys.TAB || e.key === _utils.EventKeys.SHIFT) {
      return;
    }

    keyUpTimeout.current = window.setTimeout(function () {
      setIsTyping(false);
    }, 1000);
  }, [isManualAnnouncement]);
  var handleOnInputBlur = (0, _react.useCallback)(function () {
    setIsLinkedToInput(true);
  }, []);
  (0, _react.useEffect)(function () {
    if (!inputId) return;
    var inputEl = document.getElementById(inputId);
    if (!inputEl) return;
    inputEl.addEventListener('blur', handleOnInputBlur);
    inputEl.addEventListener('keydown', handleKeyDown);
    inputEl.addEventListener('keyup', handleKeyUp);
    return function () {
      inputEl.removeEventListener('keydown', handleKeyDown);
      inputEl.removeEventListener('keyup', handleKeyUp);
      inputEl.removeEventListener('blur', handleOnInputBlur);
      clearTimeout(keyUpTimeout.current);
    };
  }, [inputId, handleKeyDown, handleKeyUp, handleOnInputBlur]);
  var announcementText;

  if (isManualAnnouncement) {
    announcementText = shouldLiveAnnounce && children;
  } else {
    announcementText = !isTyping && children;
  }

  return (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)(_inputFooter.InputFooter, {
    ref: ref,
    id: isLinkedToInput ? id : undefined,
    error: error,
    warning: warning,
    icon: icon
  }, children), (0, _core.jsx)(_screenReaderOnly.ScreenReaderOnly, {
    "aria-atomic": ariaAtomic,
    "aria-live": ariaLive,
    "aria-relevant": ariaRelevant,
    role: ariaRole
  }, announcementText));
};

RecommendedLengthFooterBase.displayName = 'RecommendedLengthFooter';
var RecommendedLengthFooter = (0, _stencilReactDesc.describe)(RecommendedLengthFooterBase).description('Footer displaying the recommended length that should be entered in an input element.');
RecommendedLengthFooter.propTypes = _objectSpread(_objectSpread({}, (0, _utils.omit)(_inputFooter.InputFooter.describedPropTypes, ['icon'])), {}, {
  progress: _stencilReactDesc.PropTypes.number.isRequired.description('Ratio of entered text and the recommended length to be displayed by the progress icon.'),
  role: _stencilReactDesc.PropTypes.string.description('Sets `role` attribute on the textarea.'),
  'aria-live': _stencilReactDesc.PropTypes.oneOf(['polite', 'assertive', 'off']).description("Sets 'aria-live' attribute on the textarea."),
  'aria-atomic': _stencilReactDesc.PropTypes.string.description("Sets 'aria-atomic' attribute on the textarea."),
  'aria-relevant': _stencilReactDesc.PropTypes.string.description("Sets 'aria-relevant' attribute on the textarea.")
});
var _default = RecommendedLengthFooter;
exports.default = _default;